/**
 * Created by luissalcedo on 1/17/17.
 */
export class Table{

  constructor(
    public $key: string,
    public restaurant_id: string,
    public tableName: string,
    public status: string,
    public statusForTable: string,
    public statusStartedTime: string, // timestamp
    public isActive: boolean,
    public edit : string,
    public seats: string

  ){};

  static fromJsonList(array): Table[]{

    return array.map(json => Table.fromJson(json));

  }


  static fromJson({$key,restaurant_id,tableName,status,statusForTable,statusStartedTime, isActive, edit,seats}) : Table {
    return new Table($key,restaurant_id,tableName,status,statusForTable,statusStartedTime,isActive, edit,seats)
  }



}

export enum tableStatus{
  Empty,
  Served,
  Cleaning,
  Waiting
}




// WEBPACK FOOTER //
// ./src/app/shared/model/table.ts